import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ planzone }) =>
    present(
      repository
        .getPlanzoneResourcesCounts()
        .then((counts) => ({ planzone, counts }))
        .catch(() => Promise.reject({ planzone })),
    );
}

export type { Interactor };

export { createInteractor };
